<template>
    <b-form-group
        :label="label"
        :label-for="id"
        :class="{
            'label-sm': labelSize === 'sm',
            'label-md': labelSize === 'md',
            'label-lg': labelSize === 'lg',
        }"
    >
        <b-input-group class="ms-text-input">
            <b-input-group-prepend
                v-if="enableIcon"
                data-toggle
            >
                <b-input-group-text class="input-group-text-coherent ">
                    <a class="input-button">
                        <i :class="icon"/>
                    </a>
                </b-input-group-text>
            </b-input-group-prepend>
            <b-form-input
                :type="type"
                :id="id"
                :value="value"
                class="form-control"
                :class="inputClass"
                :placeholder="placeholder"
                :name="name"
                :disabled="disabled"
                @input="onInput"
                :autocomplete="autocomplete"
            />
        </b-input-group>
        <input-error
            :errors="errors"
            :field="name"
        />
    </b-form-group>
</template>
<script>
import './TextInput.scss';
import {generateRandomString} from "./../../../helpers/stringHelpers";
import InputError from "../../InputError/InputError.vue";

export default {
    name: 'TextInput',
    components: {InputError},
    props: {
        value: {
            type: [
                String,
                Number
            ],
        },
        type: {
            type: String,
            required: false,
            default: () => {
                return 'text';
            }
        },
        name: {
            type: String,
            required: false,
            default: () => {
                return 'price';
            }
        },
        label: {
            type: String,
            required: false,
            default: () => {
                return '';
            }
        },
        enableIcon: {
            type: Boolean,
            required: false,
            default: () => {
                return false;
            }
        },
        icon: {
            type: String,
            required: false,
            default: () => {
                return 'far fa-dollar-sign';
            }
        },
        id: {
            type: String,
            required: false,
            default: () => {
                return generateRandomString(10);
            }
        },
        placeholder: {
            type: String,
            required: false,
            default: () => {
                return '';
            }
        },
        inputClass: {
            type: [String, Object],
            required: false,
            default: () => {
                return '';
            }
        },
        disabled: {
            type: Boolean,
            required: false,
            default: () => {
                return false;
            }
        },
        errors: {
            type: Object,
            required: false,
            default: () => ({})
        },
        labelSize: {
            type: String,
            required: false,
            default: 'sm',
            validator: (value) => {
                return [
                    'sm',
                    'md',
                    'lg'
                ].indexOf(value) > -1;
            }
        },
        autocomplete: {
            type: String,
            required: false,
            default: 'off'
        },
    },
    methods: {
        onInput(value) {
            this.$emit('input', value);
        }
    },
}
</script>
